import React from 'react'

const Heading = ({ title, subTitle, desc, id }: {
    title?: string,
    subTitle?: string,
    desc?: string,
    id?: string
}) => {
    return (
        <div id={id} className="text-center">
            {title && (
                <h1 className="text-secondary font-semibold text-2xl md:text-3xl lg:text-4xl mb-3">
                    {title}
                </h1>
            )}

            {subTitle && (
                <h2 className="text-primary font-bold text-3xl md:text-4xl lg:text-5xl mb-4 w-full">
                    {subTitle}
                </h2>
            )}

            {desc && (
                <h3 className='text-[#333] text-lg md:text-xl font-normal mt-6 text-wrap w-full md:w-3/4 mx-auto leading-relaxed'>
                    {desc}
                </h3>
            )}
        </div>
    )
}

export default Heading